<template>
	<div class="flex-column">
		<div class="full-height overflow-y-auto pb-50 mb-10">
			<div>

				<label class="h6 display-block ">
					<div
						class="justify-space-between items-center"
					>
						작업 현장

						<button
							v-if="user.member_level >= 3 && item.task_status != codes.task_status.report_status_confirm_last"
							class=" btn-primary"
							@click="toDetail"
						>정보수정 및 작업 인원 배정</button>
					</div>
					<div
						class="input-box size-px-12 font-weight-700 radius-10 mt-10"
					> {{ item.project_name }}</div>
				</label>

				<label class="h6 display-block mt-20 justify-space-between items-center">
					{{ item.task_name }}
					<span class="label " :class="'label-' + item.task_priority_color">{{ item.task_priority_name }}</span>
				</label>

				<div class="mt-10 box pa-10 radius-10">
					<template
						v-if="items_file.length > 0"
					>
						<label
							v-for="(file, f_index) in items_file"
							:key="'file_' + f_index"
						>
							<a
								:href="file.file_path"
								target="project_file"
								class="width-100 inline-block justify-space-between items-center"
							>{{ file.original_name }} <v-icon>mdi mdi-download-box</v-icon></a>
						</label>
					</template>
					<div
						v-else
					>첨부파일이 없습니다.</div>
				</div>

				<div
					class="mt-10 box pa-10 radius-10"
					:inner-html.prop="item.task_content ? item.task_content : '작업 내용이 없습니다' | nl2br"
				></div>

				<div class="mt-10 box pa-10 radius-10">
					{{ item.task_location ? item.task_location : '작업 위치 정보가 없습니다' }}
				</div>

				<div class="mt-10 box pa-10 radius-10">
					{{ item.sDate }} ~ {{ item.eDate }}
				</div>

				<div
					class="mt-10 justify-space-between gap-10 box pa-10 radius-10"
					:class="'bg-' + item.task_status_color"
				>
					<span class=" " >{{ item.task_status_name }}</span>
					<span>{{ item_status.wDate }}</span>
				</div>

				<div
					v-if="item.task_status == codes.task_status.report_status_return || item.task_status == codes.task_status.report_status_return_last"
					class="mt-10 box pa-10 radius-10">
					{{ item_status.report_message }}
				</div>
			</div>

			<div
				class="mt-10"
			>

				<label class="h6 display-block mt-10">
					작업 인원
				</label>

				<div>
					<ul
						v-if="member_list.length > 0"
					>
						<template
							v-for="member in member_list"
						>
							<li
								v-if="member.status == '1'"
								:key="'member_' + member.member_id"
								class="box radius-10 pa-10 mt-10 justify-space-between gap-10 items-center cursor-pointer"
								:class="{'box-primary':member.status == '1'  }"
								@click="copy(member)"
							>
								{{ member.member_name }} ( {{ member.member_id }} )

								<v-icon
									v-if="user.member_level >= 3"
								>mdi mdi-link-box-variant-outline</v-icon>
							</li>
						</template>
					</ul>
					<Empty
						v-else
						class="mt-10"
						text="등록된 인원이 없습니다."
					></Empty>
				</div>
			</div>

			<div class="mt-20">

				<label class="h6 display-block mt-10 justify-space-between items-center">
					작업일지 내역

					<button
						v-if="user.member_level != 3 && item.task_status > 0 && item.task_status != codes.task_status.report_status_confirm_last"
						class="btn btn-primary"

						@click="toReport"
					>작업일지 등록</button>
				</label>

				<div class="mt-10">
					<ul
						v-if="items_report.length > 0"
					>
						<template
							v-for="report in items_report"
						>
							<li
								:key="'report_' + report.uid"
								class="box radius-10 pa-10 mt-10  "
								:class="{'box-primary':report.status == '1'  }"
							>
								<div>
									<div class="font-weight-bold justify-space-between gap-10 items-center">
										<span>
											{{ report.rDate }}&nbsp;
											{{ report.member_name }}
											({{ report.member_id }})
										</span>

										<span>
											<button
												@click="toView(report)"
											><v-icon class="">mdi mdi-arrow-right-bold-box</v-icon></button>

											<button
												v-if="user.member_level < 3"
												@click="deleteReport(report)"
											><v-icon class="">mdi mdi-close-box</v-icon></button>
										</span>

										<span
											v-if="false"
											class="label" :class="'label-' + report.status_color">{{ report.status_name }}</span>
									</div>

									<div class="mt-10">{{ report.report_content | maxLength(50)}}</div>
								</div>
							</li>
						</template>
					</ul>
					<Empty
						v-else
					>등록된 작업일지가 없습니다.</Empty>
				</div>
			</div>
		</div>

		<div
			v-if="user.member_level != '3'"
			class="mt-auto justify-space-between gap-10"
		>
			<button
				v-if="item.task_status == codes.task_status.report_status_wait"
				class="btn-full btn-primary"
				@click="postTaskStatus('begin')"
			>작업시작</button>
			<button
				v-if="item.task_status == codes.task_status.report_status_begin"
				class="btn-full btn-primary"
				@click="postTaskStatus('complete')"
			>승인 요청</button>
			<button
				v-if="item.task_status == codes.task_status.report_status_return"
				class="btn-full btn-primary"
				@click="postTaskStatus('try')"
			>재승인 요청</button>
			<button
				v-if="item.task_status == codes.task_status.report_status_return_last"
				class="btn-full btn-primary"
				@click="postTaskStatus('try_last')"
			>최종 재승인 요청</button>
		</div>
		<div
			v-if="user.member_level >= 3"
			class="mt-auto justify-space-between gap-10"
		>
			<button
				v-if="item.task_status == codes.task_status.report_status_complete || item.task_status == codes.task_status.report_status_try"
				class="btn-full btn-primary"
				@click="postTaskStatus('confirm')"
			>1차 승인</button>
			<button
				v-if="item.task_status == codes.task_status.report_status_complete || item.task_status == codes.task_status.report_status_try"
				class="btn-full btn-danger"
				@click="onReturn"
			>1차 승인 반려</button>
			<button
				v-if="item.task_status == codes.task_status.report_status_confirm || item.task_status == codes.task_status.report_status_try_last"
				class="btn-full btn-primary"
				@click="postTaskStatus('confirm_last')"
			>최종 승인</button>
			<button
				v-if="item.task_status == codes.task_status.report_status_confirm || item.task_status == codes.task_status.report_status_try_last"
				class="btn-full btn-danger"
				@click="onReturnLast"
			>최종 승인 반려</button>
		</div>

		<PopupConfirm
			v-if="is_on_return"

			@cancel="offReturn"
			@click="postReturn"
		>
			<template
				slot="title"
			>작업 승인 반려</template>
			<template
				slot="content"
			>
				<textarea v-model="return_message" class="input-box" placeholder="사유를 입력하세요">
				</textarea>
			</template>
		</PopupConfirm>


		<PopupConfirm
			v-if="is_on_return_last"

			@cancel="offReturn"
			@click="postReturnLast"
		>
			<template
				slot="title"
			>작업 승인 반려</template>
			<template
				slot="content"
			>
				<textarea v-model="return_message" class="input-box" placeholder="사유를 입력하세요">
				</textarea>
			</template>
		</PopupConfirm>
	</div>
</template>

<script>

import Empty from "../Layout/Empty";
import PopupConfirm from "../Layout/PopupConfirm";
export default {
	name: 'ProjectTaskView'
	, components: {PopupConfirm, Empty}
	, props: ['user', 'codes']
	, data: function(){
		return {
			program: {
				name: '작업 상세 정보'
				, not_top: true
				, title: true
				, bottom: false
				, is_container: true
				, from: 'Index'
			}
			, item: {
				work_content: ''
			}
			, task_idx: this.$route.params.idx
			, items_member: []
			, items_report: []
			, items_file: []
			, is_on_return: false
			, return_message: ''
			, is_on_return_last: false
			, item_status: {}
		}
	}
	, computed: {
		member_list: function(){
			return this.items_member.filter( (item) => {
				if(item.status == '1'){
					return item
				}
			})
		}
	}
	, methods: {
		getData: async function(){
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'get'
					, url: 'project/getProjectTask'
					, data: {
						idx: this.task_idx
					}
				})

				if(result.success){
					this.item = result.data.task_info
					this.items_member = result.data.member_list
					this.items_report = result.data.report_list
					this.items_file = result.data.file_list
					this.item_status = result.data.last_status
					this.$bus.$emit('notify', { type: 'success', message: result.message})
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, toDetail: function (){
			this.$bus.$emit('to', {name: 'ProjectTaskDetail', params: { idx: this.task_idx}})
		}
		, toReport: function(){
			this.$bus.$emit('to', {name: 'ProjectReport', params: { idx: this.task_idx}})
		}
		, toView: function(report){
			this.$bus.$emit('to', {name: 'ProjectReportView', params: { idx: report.uid }})
		}

		, clipBoard: function (value) {
			const t = document.createElement("textarea");
			document.body.appendChild(t);
			t.value = value;
			t.select();
			document.execCommand('copy');
			document.body.removeChild(t);
		}

		, copy: function (member) {
			if(this.user.member_level == 3){
				if(member.user_link){
					this.clipBoard(this.$https + '/Auth/Login/' + this.item.project_uid + '/' + member.user_link);
					alert('작업링크가 복사되었습니다.');
				}else{
					alert('작업링크가 없습니다.');
				}
			}
		}
		, postTaskStatus: async function(type){

			let t = '처리 하시겠습니까?'

			switch (type){
				case 'confirm':
					t = '승인' + t
					break;
				case 'return':
					t = '반려' + t
					break;
				case 'begin':
					t = '작업 시작' + t
					break;
				case 'try':
					t = '승인 요청 ' + t
					break;
				case 'try_last':
					t = '최종 승인 요청 ' + t
					break;
			}

			if(!confirm(t)){
				return false
			}
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'post'
					, url: 'project/postTaskStatus'
					, data: {
						idx: this.task_idx
						, task_status_type: type
						, return_message: this.return_message
					}
				})

				if(result.success){
					this.$bus.$emit('notify', { type: 'success', message: result.message})
					await this.getData()
					this.offReturn()
				}else{
					throw result.message
				}

			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
				this.is_on_return = false
			}
		}
		, onReturn: function(){
			this.is_on_return = true
			this.return_message = ''
		}
		, onReturnLast: function(){
			this.is_on_return_last = true
			this.return_message = ''
		}
		, offReturn: function(){
			this.is_on_return = false
			this.is_on_return_last = false
			this.return_message = ''
		}
		, postReturn: function(){
			this.postTaskStatus('return')
		}
		, postReturnLast: function(){
			this.postTaskStatus('return_last')
		}
		, deleteReport: async function(report){
			if(confirm("해당 작업일지를 삭제하시겠습니까?")){
				this.$bus.$emit('on', true)
				try {
					const result = await this.$request.init({
						method: 'post'
						, url: 'project/deleteReport'
						, data: {
							idx: report.uid
						}
					})

					if(result.success){
						this.$bus.$emit('notify', { type: 'success', message: result.message})
						await this.getData()
					}else{
						throw result.message
					}

				}catch (e){
					this.$bus.$emit('notify', { type: 'error', message: e})
				}finally {
					this.$bus.$emit('on', false)
				}
			}
		}
	}
	, created() {
		this.$bus.$emit('onLoad', this.program)
		this.getData()
	}
}
</script>